import Toggle, {Size} from '@jetbrains/ring-ui/components/toggle/toggle'
import React, {useCallback, useContext} from 'react'

import Markdown, {LinkOpenPolicy} from '../../../../../../../../../../common/Markdown/Markdown'
import {DisabledContext} from '../../../../../../../../contexts/DisabledContext'
import Details from '../../../../../../Details/Details'

import styles from './JobStepBooleanProperty.css'

type Props = {
  name: string
  label?: string
  value: string
  stepIndex: number
  onChange: (stepIndex: number, name: string, value: string) => void
  updated?: boolean
  description?: string | null
  trueValue?: string
  falseValue?: string
}

export function JobStepBooleanProperty({
  stepIndex,
  onChange,
  value,
  name,
  label,
  description,
  trueValue = 'true',
  falseValue = '',
}: Props) {
  const onInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(stepIndex, name, event.currentTarget.checked ? trueValue : falseValue)
    },
    [onChange, stepIndex, name, trueValue, falseValue],
  )

  const isDisabled = useContext(DisabledContext)

  return (
    <div className={styles.container}>
      <Toggle
        className={styles.toggle}
        size={Size.Size16}
        checked={value === trueValue}
        onChange={onInputChange}
        disabled={isDisabled}
      >
        {label}
        {description && (
          <Details>
            <Markdown className={styles.description} linkOpenPolicy={LinkOpenPolicy.ALL_IN_NEW_TAB}>
              {description}
            </Markdown>
          </Details>
        )}
      </Toggle>
    </div>
  )
}
